export default theme => ({
  textField: {
    paddingRight: '12px',
    width: '100%',
    maxWidth: '300px',
  },
});
